import { Checkbox, CheckboxGroup } from '@billy/design-system'
import { useCallback } from 'react'

import { useInvoiceColumnVisibilitySettingsForm } from '../../../../../../../../../../../../contexts/invoiceColumnVisibilityFormContext'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useInvoiceLineHeaderLabels } from '../../../../../../../../hooks/useInvoiceLineHeaderLabels'
import { InvoiceColumnsVisibilitySettingsSection } from '../InvoiceColumnsVisibilitySettingsSection'

export const OptionalColumnsSettings = () => {
  const { getHeaderLabel } = useInvoiceLineHeaderLabels()
  const { invoiceLinesColumnsVisibilityForm, isLoading } = useInvoiceColumnVisibilitySettingsForm()
  const { trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceLinesColumnsVisibilityForm

  const handleVisibleColumnsChange = useCallback(
    (visibleColumns: string[]) => {
      trackInvoiceEditor('Column visibility changed', { visibleColumns })
    },
    [trackInvoiceEditor],
  )

  return (
    <InvoiceColumnsVisibilitySettingsSection>
      <FormItem
        name="selectedColumns"
        render={({ field: { value, onChange, ...props } }) => {
          return (
            <CheckboxGroup
              {...props}
              defaultValue={value}
              direction="column"
              disabled={isLoading}
              onChangeMultiple={(value: string[]) => {
                onChange(value)
                handleVisibleColumnsChange(value)
              }}
              value={value}
            >
              <Checkbox value="date">{getHeaderLabel('date')}</Checkbox>
              <Checkbox value="unit">{getHeaderLabel('unit')}</Checkbox>
            </CheckboxGroup>
          )
        }}
      />
    </InvoiceColumnsVisibilitySettingsSection>
  )
}
